import React from 'react';
import PropTypes from 'prop-types';
import { SubmitButton } from '../sign-up/signup.styles';
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';

const styles = {
  loginWrapper: {
    textAlign: 'center',
    height: 'auto',
    backgroundColor: 'transparent'
  }
};

const FormWrapper = (props) => {
  return (
    <StyledRow>
      <BaseColumn
        {...props.size}
        customstyle={styles.loginWrapper}
      >
        {props.header}

        {props.children}

        {props.hasSubmit && 
          <StyledRow customstyle={{ marginTop: '1.65rem', width: '100%', display: 'block' }}>
            <SubmitButton
                disabled={props.submitDisabled}
                onClick={props.onSubmit}
                customstyle={props.submitLabel === 'Entrar' ? {
                  color: 'white',
                  width: '100%',
                  maxWidth: '100%',
                  padding: '12px 1.25rem',
                  borderRadius: '12px',
                  borderColor: 'transparent',
                  fontWeight: 600,
                  fontSize: '0.9375rem',
                  letterSpacing: '0.03em',
                  background: 'linear-gradient(180deg, #1e4a86 0%, #0f2a52 100%)',
                  boxShadow: '0 6px 20px rgba(0, 21, 55, 0.38)',
                } : {
                  color: 'white',
                  padding: '.3rem 1.5rem .3rem 1.5rem',
                  borderColor: 'transparent',
                  fontWeight: 300,
                }}
              >
              {props.submitLabel || 'Salvar'}
            </SubmitButton>
          </StyledRow>
        }

        {props.footer}
      </BaseColumn>
    </StyledRow>
  );
}

FormWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
};

FormWrapper.defaultProps = {
  hasSubmit: true,
  header: null,
  footer: null,
  size: {
    xl: 7,
    lg: 7,
    md: 7,
    sm: 7,
    col: 7
  }
}

export default FormWrapper;